module.exports = __webpack_public_path__ + "img/4-certifications-ml_cut.png";